module.exports = __webpack_public_path__ + "img/swiper_02.93aa278f.jpg";